module.exports = __webpack_public_path__ + "img/MEDIA110.203d0602.jpg";